class LogOutputComposite {
  LogOutputList = new Map();

  Register(name, component) {
    if (!!!this.LogOutputList.get(name))
      this.LogOutputList.set(name, component);
  }

  Unregister(name) {
    if (!!this.LogOutputList.get(name)) this.LogOutputList.delete(name);
  }

  Save(msg) {
    this.LogOutputList.forEach((item) => {
      item.Save(msg);
    });
  }
}

export default LogOutputComposite;
